import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import Keyboard from "simple-keyboard";
import { KeyboardService } from '../../keyboard/keyboard.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.sass'],
})
export class SearchInputComponent implements OnInit, AfterContentChecked, OnDestroy {

  keyboard: Keyboard;

  @ViewChildren('searchInput')
  searchInput: QueryList<ElementRef>;

  @Input()
  search = '';

  @Input()
  showIcon: boolean = true;

  @Input()
  placeHolder: string = '';

  @Output()
  onChange: EventEmitter<any> = new EventEmitter();
  keyboardChangeFireSub: Subscription;
  keyboardChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private cd: ChangeDetectorRef,
    public keyboardService: KeyboardService) {
    }

  ngOnInit(): void {
    this.cd.detach();
    this.keyboardChangeFireSub = this.keyboardChange.subscribe((event: string) => {
      this.search = event;
      this.onChange.emit({ filter: this.search, event: new Event('keyup') });
    });
  }

  ngOnDestroy(): void {
    this.keyboardChangeFireSub.unsubscribe();
  }

  ngAfterContentChecked(): void {
    this.cd.detectChanges();
  }

  clear() {
    this.search = '';
    this.onChange.emit('');
  }

}
